module.exports = __webpack_public_path__ + "img/underline-01.3a544aa2.svg";